import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const NumberOfKURPICDCallsByLeaders = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Number of KURPICD calls by leaders" />
    </Box>
  );
};
